var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:_vm.GetResponsiveClass,attrs:{"id":"login-footer"}},[_vm._m(0)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{attrs:{"id":"copyright"}},[_c('label',[_vm._v("Todos los Derechos Reservados © 2026")])])
}]

export { render, staticRenderFns }